import React from 'react';
import './style.scss';
import {
  RichText,
  Text,
  Link as JSSLink,
  useSitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';
import icons from '../../../../../common/Icons';
import Button from '../../../../Shared/components/controls/Button';
import clsx from 'clsx';
import { cardsCompareFeatureTypes } from '../../../utils';
import { CheckIcon, CrossIcon } from '../../icons';

const CardsListCardDescription = ({
  heading,
  text,
  link,
  features,
  offer,
  className,
  linkHover = false,
}) => {
  if (linkHover && link?.value?.href) {
    return (
      <JSSLink
        field={link}
        className={clsx('cl-card-description', 'cl-card-desc-link-hover', className)}
      >
        <Title text={heading} />
        <Description text={text} />
        <Features features={features} />
        <Offer data={offer} />
        <Link link={link} disableLink />
      </JSSLink>
    );
  }

  return (
    <div className={clsx('cl-card-description', className)}>
      <Title text={heading} />
      <Description text={text} />
      <Features features={features} />
      <Offer data={offer} />
      <Link link={link} />
    </div>
  );
};

const Title = ({ text }) => {
  if (!text?.value) return null;

  return (
    <div className="cl-card-desc-title">
      <Text field={text} />
    </div>
  );
};

const Description = ({ text }) => {
  if (!text?.value) return null;

  return <RichText className="cl-card-desc-text" field={text} />;
};

const Features = ({ features }) => {
  const context = useSitecoreContext();
  const currency = context?.sitecoreContext?.siteConfigurations?.currency || 'AED';
  if (!features?.length) return null;

  const Content = ({ data }) => {
    switch (data.valueType) {
      case cardsCompareFeatureTypes.boolean: {
        return (
          <div className="cl-card-desc-feature-value">
            {data.value ? <CheckIcon /> : <CrossIcon />}
          </div>
        );
      }
      case cardsCompareFeatureTypes.html: {
        return (
          <div className={clsx('cl-card-desc-feature-value', 'cl-card-desc-feature-value-plain')}>
            <RichText field={{ value: data.value }} />
          </div>
        );
      }
      case cardsCompareFeatureTypes.currency: {
        return (
          <div className={clsx('cl-card-desc-feature-value')}>
            {currency} <b>{data.value}</b>
          </div>
        );
      }
      default: {
        return <div className="cl-card-desc-feature-value">{data.value}</div>;
      }
    }
  };

  return (
    <div className="cl-card-desc-features">
      {features.map((feature, index) => {
        const { nameTitle } = feature;
        return (
          <div className="cl-card-desc-feature" key={index}>
            <h5 className="cl-card-desc-feature-title">{nameTitle}</h5>
            <Content data={feature} />
          </div>
        );
      })}
    </div>
  );
};

const Offer = ({ data }) => {
  if (!data?.value) return null;

  return (
    <div className="cl-card-desc-offer">
      <div className="cl-card-desc-offer-icon">
        <img alt='' src={icons.percentage} />
      </div>
      <div className="cl-card-desc-offer-text">
        <Text field={data} />
      </div>
    </div>
  );
};

const Link = ({ link, disableLink = false }) => {
  if (!link?.value?.href) return null;

  if (disableLink) {
    return (
      <div className="cl-card-desc-link">
        <Button link={link} variant="text" arrow="right">
          {link.value.text}
        </Button>
      </div>
    );
  }

  return (
    <div className="cl-card-desc-link">
      <Button variant="text" link={link} arrow="right" />
    </div>
  );
};

export default CardsListCardDescription;
